import React from 'react'
// import PropTypes from 'prop-types'
import ScrollableAnchor from 'react-scrollable-anchor'

import Contact from '../../components/Contact'
import { Grid, Col } from '../../components/Grid'
import Helmet from '../../components/seo/Helmet'

export default function Services ({ helmetProps }) {
  return (
    <div>
      <Helmet {...helmetProps} />
      <h1>Tjenester</h1>
      <Grid list>
        <Col>
          <ScrollableAnchor id={'backend'}><h2>Backend</h2></ScrollableAnchor>
        </Col>
        <Col>
          <p>
            Appresso implementerer backend for mobil- og webapplikasjoner. Dette kan være rene headless løsninger,
            hvor deler av backend har ansvar for små eller større deler av grensesnittet. Vi har lang erfaring med
            hva som trengs for å lage en stabil, fleksibel og skalerbar løsning med lang levetid.
            Som komponenter benytter vi oftest Django, Python, Redis og PostgreSQL, men vi kan også tilby
            løsninger bygget med f.eks Wagtail eller Sanity.
          </p>
          <p>
            Appresso driver testdrevet utvikling og leverer alltid løsninger med automatiske tester.
          </p>
        </Col>
      </Grid>

      <Grid list>
        <Col>
          <ScrollableAnchor id={'frontend'}><h2>Frontend</h2></ScrollableAnchor>
        </Col>
        <Col>
          <p>
            Vi har erfarne Javascript, HTML og CSS folk, og kan tilby utvikling med bla. React.
            Når vi utvikler frontend benytter vi til vanlig flere av følgende:{' '}
            <a href="https://www.w3.org/html/">HTML</a>,{' '}
            <a href="https://reactjs.org/">React</a>,{' '}
            <a href="https://sass-lang.com/">Sass</a>,{' '}
            <a href="https://nodejs.org/en/">Node</a>,{' '}
            <a href="https://yarnpkg.com/en/">Yarn</a>,{' '}
            <a href="https://redux.js.org/">Redux</a>,{' '}
            <a href="https://www.w3schools.com/css/css3_flexbox.asp">Flexbox</a>.{' '}
          </p>
          <p>
            Når vi programmerer frontend for webapplikasjoner tar vi såklart hensyn til alle
            skjermstørrelser (responsive nettsider),{' '}
            <a href="https://en.wikipedia.org/wiki/Search_engine_optimization">SEO optimalisering</a>,{' '}
            tilgjengelighetskrav og skalerbarhet.
          </p>
        </Col>
      </Grid>

      <Grid list>
        <Col>
          <ScrollableAnchor id={'integrasjoner'}><h2>Integrasjoner og API-er</h2></ScrollableAnchor>
        </Col>
        <Col>
          <p>
            Har du behov for hjelp med integrasjon, utvikling eller bruk av API-er? Appresso har lang erfaring
            med mange typer av integrasjoner, og kan bidra til å forenkle og effektivisere slik arbeid. Vi kan
            sette opp mikrotjenester eller egne plattformer som henter, prosesserer og leverer data for
            mange bruksområder. Nøkkelord for dette arbeidet er{' '}
            <a href="https://en.wikipedia.org/wiki/Representational_state_transfer">REST</a>,{' '}
            <a href="https://www.json.org/">JSON</a>,{' '}
            <a href="https://en.wikipedia.org/wiki/Web_API_security">API-sikkerhet</a>.
          </p>
        </Col>
      </Grid>

      <Grid list>
        <Col>
          <ScrollableAnchor id={'driftcloud'}><h2>Drift og cloud</h2></ScrollableAnchor>
        </Col>
        <Col>
          <p>
            For de aller fleste av våre kunder benytter vi{' '}
            <a href="https://www.heroku.com">Heroku</a>{' '}
            for hosting og
            drift av webapplikasjoner. Heroku er en skyplattform med høyt fokus
            på oppetid, skalerbarhet og sikkerhet. Med Heroku riktig konfigurert
            og satt opp får du som kunde mest for pengene.
          </p>
          <p>
            Appresso er markedsledende på drift og hosting på Heroku i Norge.
          </p>
        </Col>
      </Grid>

      <Grid list>
        <Col>
          <h2>Programmering</h2>
        </Col>
        <Col>
          <p>
            Vi kan programmere alt i Python og JavaScript, men har også lang
            erfaring med mange andre språk. Triggere i SQL for databaser, og
            utvidelser av spillmotoren i Unreal Engine med <a href="http://www.cplusplus.org/">C++</a> er eksempler
            på oppdrag Appresso har gjennomført.
          </p>
        </Col>
      </Grid>

      <Grid list>
        <Col>
          <h2>Råd og veiledning</h2>
        </Col>
        <Col>
          <p>
            Vår erfaring og kunnskap kan være til stor nytte for deg. Vi vil
            gjerne høre, gi gode råd, veilede og bidra slik at du får den
            best mulige løsningen.
          </p>
        </Col>
      </Grid>

      <Contact
        who="tor"
        title="Lurer du på noe?"
      >
        Ta kontakt med <strong>Tor Ivar</strong> om du har spørsmål om hva
        Appresso kan levere.
      </Contact>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/pages/Services/index.js